import React from 'react'
import Title from '../components/Title'

import BannerSection from '../BannerSection/BannerSection'
import CalloutSection from '../CalloutSection/CalloutSection'
import FeaturesSection from '../FeaturesSection/FeaturesSection'
import ReferencesSection from '../ReferencesSection/ReferencesSection'
import ContactSection from '../ContactSection/ContactSection'

import './Page.scss'

const Page = (props) => (
  <main className="page">
    <Title message="Stadyum CRM" />
    <BannerSection />
    <CalloutSection />
    <FeaturesSection />
    <ReferencesSection />
    <ContactSection />
  </main>
)

Page.propTypes = {
  component: React.PropTypes.func,
}

export default Page



// WEBPACK FOOTER //
// ./src/browser/app/Page.js